/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppReceitaRouteImport } from './routes/_app.receita'
import { Route as AppPopupsRouteImport } from './routes/_app.popups'
import { Route as AppPagamentosRouteImport } from './routes/_app.pagamentos'
import { Route as AppOrganizacoesRouteImport } from './routes/_app.organizacoes'
import { Route as AppGastosRouteImport } from './routes/_app.gastos'
import { Route as AppAuditoriaRouteImport } from './routes/_app.auditoria'
import { Route as AppAssinaturasRouteImport } from './routes/_app.assinaturas'
import { Route as AppOrganizacoesIndexRouteImport } from './routes/_app.organizacoes.index'
import { Route as AppOrganizacoesOrgIdRouteImport } from './routes/_app.organizacoes.$orgId'
import { Route as AppOrganizacoesOrgIdExclusaoRouteImport } from './routes/_app.organizacoes.$orgId_.exclusao'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppReceitaRoute = AppReceitaRouteImport.update({
  id: '/receita',
  path: '/receita',
  getParentRoute: () => AppRoute,
} as any)
const AppPopupsRoute = AppPopupsRouteImport.update({
  id: '/popups',
  path: '/popups',
  getParentRoute: () => AppRoute,
} as any)
const AppPagamentosRoute = AppPagamentosRouteImport.update({
  id: '/pagamentos',
  path: '/pagamentos',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizacoesRoute = AppOrganizacoesRouteImport.update({
  id: '/organizacoes',
  path: '/organizacoes',
  getParentRoute: () => AppRoute,
} as any)
const AppGastosRoute = AppGastosRouteImport.update({
  id: '/gastos',
  path: '/gastos',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditoriaRoute = AppAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => AppRoute,
} as any)
const AppAssinaturasRoute = AppAssinaturasRouteImport.update({
  id: '/assinaturas',
  path: '/assinaturas',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizacoesIndexRoute = AppOrganizacoesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrganizacoesRoute,
} as any)
const AppOrganizacoesOrgIdRoute = AppOrganizacoesOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => AppOrganizacoesRoute,
} as any)
const AppOrganizacoesOrgIdExclusaoRoute =
  AppOrganizacoesOrgIdExclusaoRouteImport.update({
    id: '/$orgId_/exclusao',
    path: '/$orgId/exclusao',
    getParentRoute: () => AppOrganizacoesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/assinaturas': typeof AppAssinaturasRoute
  '/auditoria': typeof AppAuditoriaRoute
  '/gastos': typeof AppGastosRoute
  '/organizacoes': typeof AppOrganizacoesRouteWithChildren
  '/pagamentos': typeof AppPagamentosRoute
  '/popups': typeof AppPopupsRoute
  '/receita': typeof AppReceitaRoute
  '/organizacoes/$orgId': typeof AppOrganizacoesOrgIdRoute
  '/organizacoes/': typeof AppOrganizacoesIndexRoute
  '/organizacoes/$orgId/exclusao': typeof AppOrganizacoesOrgIdExclusaoRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/assinaturas': typeof AppAssinaturasRoute
  '/auditoria': typeof AppAuditoriaRoute
  '/gastos': typeof AppGastosRoute
  '/pagamentos': typeof AppPagamentosRoute
  '/popups': typeof AppPopupsRoute
  '/receita': typeof AppReceitaRoute
  '/': typeof AppIndexRoute
  '/organizacoes/$orgId': typeof AppOrganizacoesOrgIdRoute
  '/organizacoes': typeof AppOrganizacoesIndexRoute
  '/organizacoes/$orgId/exclusao': typeof AppOrganizacoesOrgIdExclusaoRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/assinaturas': typeof AppAssinaturasRoute
  '/_app/auditoria': typeof AppAuditoriaRoute
  '/_app/gastos': typeof AppGastosRoute
  '/_app/organizacoes': typeof AppOrganizacoesRouteWithChildren
  '/_app/pagamentos': typeof AppPagamentosRoute
  '/_app/popups': typeof AppPopupsRoute
  '/_app/receita': typeof AppReceitaRoute
  '/_app/': typeof AppIndexRoute
  '/_app/organizacoes/$orgId': typeof AppOrganizacoesOrgIdRoute
  '/_app/organizacoes/': typeof AppOrganizacoesIndexRoute
  '/_app/organizacoes/$orgId_/exclusao': typeof AppOrganizacoesOrgIdExclusaoRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/assinaturas'
    | '/auditoria'
    | '/gastos'
    | '/organizacoes'
    | '/pagamentos'
    | '/popups'
    | '/receita'
    | '/organizacoes/$orgId'
    | '/organizacoes/'
    | '/organizacoes/$orgId/exclusao'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/assinaturas'
    | '/auditoria'
    | '/gastos'
    | '/pagamentos'
    | '/popups'
    | '/receita'
    | '/'
    | '/organizacoes/$orgId'
    | '/organizacoes'
    | '/organizacoes/$orgId/exclusao'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/assinaturas'
    | '/_app/auditoria'
    | '/_app/gastos'
    | '/_app/organizacoes'
    | '/_app/pagamentos'
    | '/_app/popups'
    | '/_app/receita'
    | '/_app/'
    | '/_app/organizacoes/$orgId'
    | '/_app/organizacoes/'
    | '/_app/organizacoes/$orgId_/exclusao'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/receita': {
      id: '/_app/receita'
      path: '/receita'
      fullPath: '/receita'
      preLoaderRoute: typeof AppReceitaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/popups': {
      id: '/_app/popups'
      path: '/popups'
      fullPath: '/popups'
      preLoaderRoute: typeof AppPopupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pagamentos': {
      id: '/_app/pagamentos'
      path: '/pagamentos'
      fullPath: '/pagamentos'
      preLoaderRoute: typeof AppPagamentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizacoes': {
      id: '/_app/organizacoes'
      path: '/organizacoes'
      fullPath: '/organizacoes'
      preLoaderRoute: typeof AppOrganizacoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gastos': {
      id: '/_app/gastos'
      path: '/gastos'
      fullPath: '/gastos'
      preLoaderRoute: typeof AppGastosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/auditoria': {
      id: '/_app/auditoria'
      path: '/auditoria'
      fullPath: '/auditoria'
      preLoaderRoute: typeof AppAuditoriaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assinaturas': {
      id: '/_app/assinaturas'
      path: '/assinaturas'
      fullPath: '/assinaturas'
      preLoaderRoute: typeof AppAssinaturasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizacoes/': {
      id: '/_app/organizacoes/'
      path: '/'
      fullPath: '/organizacoes/'
      preLoaderRoute: typeof AppOrganizacoesIndexRouteImport
      parentRoute: typeof AppOrganizacoesRoute
    }
    '/_app/organizacoes/$orgId': {
      id: '/_app/organizacoes/$orgId'
      path: '/$orgId'
      fullPath: '/organizacoes/$orgId'
      preLoaderRoute: typeof AppOrganizacoesOrgIdRouteImport
      parentRoute: typeof AppOrganizacoesRoute
    }
    '/_app/organizacoes/$orgId_/exclusao': {
      id: '/_app/organizacoes/$orgId_/exclusao'
      path: '/$orgId/exclusao'
      fullPath: '/organizacoes/$orgId/exclusao'
      preLoaderRoute: typeof AppOrganizacoesOrgIdExclusaoRouteImport
      parentRoute: typeof AppOrganizacoesRoute
    }
  }
}

interface AppOrganizacoesRouteChildren {
  AppOrganizacoesOrgIdRoute: typeof AppOrganizacoesOrgIdRoute
  AppOrganizacoesIndexRoute: typeof AppOrganizacoesIndexRoute
  AppOrganizacoesOrgIdExclusaoRoute: typeof AppOrganizacoesOrgIdExclusaoRoute
}

const AppOrganizacoesRouteChildren: AppOrganizacoesRouteChildren = {
  AppOrganizacoesOrgIdRoute: AppOrganizacoesOrgIdRoute,
  AppOrganizacoesIndexRoute: AppOrganizacoesIndexRoute,
  AppOrganizacoesOrgIdExclusaoRoute: AppOrganizacoesOrgIdExclusaoRoute,
}

const AppOrganizacoesRouteWithChildren = AppOrganizacoesRoute._addFileChildren(
  AppOrganizacoesRouteChildren,
)

interface AppRouteChildren {
  AppAssinaturasRoute: typeof AppAssinaturasRoute
  AppAuditoriaRoute: typeof AppAuditoriaRoute
  AppGastosRoute: typeof AppGastosRoute
  AppOrganizacoesRoute: typeof AppOrganizacoesRouteWithChildren
  AppPagamentosRoute: typeof AppPagamentosRoute
  AppPopupsRoute: typeof AppPopupsRoute
  AppReceitaRoute: typeof AppReceitaRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAssinaturasRoute: AppAssinaturasRoute,
  AppAuditoriaRoute: AppAuditoriaRoute,
  AppGastosRoute: AppGastosRoute,
  AppOrganizacoesRoute: AppOrganizacoesRouteWithChildren,
  AppPagamentosRoute: AppPagamentosRoute,
  AppPopupsRoute: AppPopupsRoute,
  AppReceitaRoute: AppReceitaRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
